import { createFileRoute, redirect } from "@tanstack/react-router";

import { MergeAccounts } from "@/components/account/merge-accounts";

interface MergeSearch {
  token?: string;
  returnTo?: string;
}

/**
 * Account merge wizard (legacy /account/user/settings/merge).
 *
 * Requires a `?token=` merge-intent JWT minted by POST /api/auth/merge-token
 * (reached from the linked-accounts conflict flow or the profile-claim flow).
 * Without a token the page is meaningless — bounce to the accounts tab.
 * `returnTo` lets an in-progress flow (e.g. a claim) resume after the merge.
 */
export const Route = createFileRoute("/_authenticated/account/user/settings/merge")({
  validateSearch: (search: Record<string, unknown>): MergeSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (!search.token) {
      throw redirect({ to: "/account/user/settings", search: { tab: "accounts" } });
    }
  },
  component: MergeAccountsPage,
});

function MergeAccountsPage() {
  const { token, returnTo } = Route.useSearch();
  // beforeLoad guarantees the token; the guard only narrows the optional type.
  if (!token) return null;
  return <MergeAccounts token={token} returnTo={returnTo} />;
}
